import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function scanNetwork(includePorts = false, subnets = "") {
  const params = {};
  if (includePorts) params.ports = "true";
  if (subnets && subnets.trim()) params.subnets = subnets.trim();
  const res = await axios.get(`${API}/scan`, { params, timeout: 180000 });
  return res.data;
}

export async function getLastScan() {
  const res = await axios.get(`${API}/scan/last`);
  return res.data;
}

export async function getHistory(limit = 20) {
  const res = await axios.get(`${API}/scan/history`, { params: { limit } });
  return res.data.history || [];
}

export async function speedTest() {
  const res = await axios.get(`${API}/speedtest`, { timeout: 30000 });
  return res.data;
}

export async function getLatency() {
  const res = await axios.get(`${API}/latency`, { timeout: 8000 });
  return res.data;
}

export async function scanDemo() {
  const res = await axios.get(`${API}/scan/demo`);
  return res.data;
}
